import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="container-page py-16 text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="container-page py-24 text-center">
        <h1 className="font-display text-4xl font-bold text-primary">Not authorized</h1>
        <p className="mt-2 text-muted-foreground">You don't have access to this page.</p>
        <Link to="/" className="btn-secondary mt-6 inline-flex">Back home</Link>
      </div>
    );
  }
  return children;
}
